<template>
  <div class="truncated-link">
    <b-link
      :href="href"
      target="_blank"
      class="d-flex align-items-center"
      rel="noopener noreferrer"
    >
      <span
        class="text-truncate"
        :title="text"
      >{{ text }}</span>

      <font-awesome-icon
        :icon="['fa', 'external-link-alt']"
        class="ml-2"
        size="sm"
      />
    </b-link>
  </div>
</template>

<script>
export default {
  name: 'TruncatedLink',
  props: {
    /**
     * The text to display (will be truncated if too long)
     */
    text: {
      type: String,
      required: true
    },
    /**
     * The URL for the link
     */
    href: {
      type: String,
      required: true
    },
  }
}
</script>

<style scoped>
.truncated-link {
  max-width: 100%;
  overflow: hidden;
}
</style>